import axios from "axios";
import { getCookie } from "../getcookie.js";
const apiUrl = process.env.REACT_APP_API_URL;
const apiAccUrl = process.env.REACT_APP_ADMIN_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

//Dashboard Counts
export const getCountsApi = async (params) => {
  try {
    const response = await axios.get(apiUrl + `dashboard/count`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

//Asset Activity
export const getActivityApi = async (params = {}) => {
  try {
    if (!params.period && params.month && params.year) {
      const paddedMonth = String(params.month).padStart(2, "0");
      params.period = `${params.year}-${paddedMonth}`;
      delete params.month;
      delete params.year;
    }

    const response = await axios.post(apiUrl + `dashboard/asset_activity`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};

//Consumption
export const getConsumptionApi = async (params = {}) => {
  try {
    if (!params.from_date && params.month && params.year) {
      const paddedMonth = String(params.month).padStart(2, "0");
      params.from_date = `${params.year}-${paddedMonth}-01`;

      const lastDay = new Date(params.year, params.month, 0).getDate();
      params.to_date = `${params.year}-${paddedMonth}-${lastDay}`;

      delete params.month;
      delete params.year;
    }

    const response = await axios.post(apiUrl + `dashboard/location_consumption`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};

//Top & Least Usage
export const getTlusageApi = async (params = {}) => {
  try {
    if (!params.period && params.month && params.year) {
      const paddedMonth = String(params.month).padStart(2, "0");
      params.period = `${params.year}-${paddedMonth}`;
      delete params.month;
      delete params.year;
    }

    const response = await axios.post(apiUrl + `dashboard/topleast_usage`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};

export const getGatelogApi = async (params = {}) => {
  try {
    if (!params.period && params.month && params.year) {
      const paddedMonth = String(params.month).padStart(2, "0");
      params.period = `${params.year}-${paddedMonth}`;
      delete params.month;
      delete params.year;
    }

    const response = await axios.post(apiUrl + `dashboard/gatelog_activity`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
export const getyearTotalApi = async (params = {}) => {
  try {

    const response = await axios.post(apiUrl + `dashboard/year_month_cost`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
export const getMonthTotalApi = async (params = {}) => {
  try {

    const response = await axios.post(apiUrl + `dashboard/month_cost`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
export const getDeprecitTotalApi = async (params = {}) => {
  try {

    const response = await axios.post(apiUrl + `dashboard/monthly_deprication`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
export const getEmployeeApi = async (params = {}) => {
  try {

    const response = await axios.post(apiUrl + `dashboard/employee_asset`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
export const getCurrentValueApi = async () => {
  try {

    const response = await axios.get(apiUrl + `dashboard/current_value`,  {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};

export const getDailyprograssApi = async (params = {}) => {
  try {
    const response = await axios.post(apiUrl + `dashboard/daily_progress`, params, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching activity:", err);
  }
};
